import React, { useMemo, useState } from "react"
import PropTypes, { object, string } from "prop-types"
import Button from "@/components/core/Button/Button"
import styles from "./index.module.scss"
import ContactCustomerModal from "./ContactCustomerModal"
import {
  formatAddress,
  formatMobileNumber,
  formatName,
} from "@/components/cart/utils"

function CustomerInformation(props) {
  const { address = {}, email = "", staticText } = props
  const [showContactCustomerModal, setShowContactCustomerModal] =
    useState(false)
  const { phone = "" } = address

  const formattedMobileNumber = useMemo(
    () => formatMobileNumber(phone),
    [phone]
  )

  const formattedName = useMemo(() => formatName(address), [address])

  const formattedAddress = useMemo(() => formatAddress(address), [address])

  const handleContactCustomer = () => {
    setShowContactCustomerModal(true)
  }

  const contactViaEmail = `mailto:${email}`
  const contactViaPhone = `tel:${phone}`

  const isContactCustomerButtonDisabled =
    !email && !phone && !formattedMobileNumber

  return (
    <div className={styles.CustomerInformationWrapper}>
      <div className="CustomerInformation__title">
        {staticText.customerInformation}
      </div>
      <div className="CustomerInformation__field-wrapper">
        {formattedName ? (
          <div className="CustomerInformation__name CustomerInformation__field">
            <div className="CustomerInformation__name CustomerInformation__field-title">
              {staticText.name}
            </div>
            <div className="CustomerInformation__name CustomerInformation__field-value">
              {formattedName}
            </div>
          </div>
        ) : null}
        {email ? (
          <div className="CustomerInformation__email CustomerInformation__field">
            <div className="CustomerInformation__email CustomerInformation__field-title">
              {staticText.email}
            </div>
            <div className="CustomerInformation__email CustomerInformation__field-value">
              {email}
            </div>
          </div>
        ) : null}

        {formattedMobileNumber ? (
          <div className="CustomerInformation__mobile CustomerInformation__field">
            <div className="CustomerInformation__mobile CustomerInformation__field-title">
              {staticText.mobileNumber}
            </div>
            <div className="CustomerInformation__mobile CustomerInformation__field-value">
              +91{formattedMobileNumber}
            </div>
          </div>
        ) : null}
        {formattedAddress ? (
          <div className="CustomerInformation__address CustomerInformation__field">
            <div className="CustomerInformation__address CustomerInformation__field-title">
              {staticText.address}
            </div>
            <div className="CustomerInformation__address CustomerInformation__field-value">
              {formattedAddress}
            </div>
          </div>
        ) : null}
      </div>
      {formattedMobileNumber || email ? (
        <Button
          ariaLabel={staticText.contactCustomer}
          className="gbh-data-layer CustomerInformation__contactCustomer-btn"
          label={staticText.contactCustomer}
          flexible
          type="ghost"
          onClick={handleContactCustomer}
          disabled={isContactCustomerButtonDisabled}
        />
      ) : null}
      <ContactCustomerModal
        staticText={staticText}
        contactViaEmail={email ? contactViaEmail : null}
        contactViaPhone={formattedMobileNumber ? contactViaPhone : null}
        showModal={showContactCustomerModal}
        closeModal={() => setShowContactCustomerModal(false)}
      />
    </div>
  )
}

CustomerInformation.propTypes = {
  name: string,
  email: string,
  mobile: string,
  address: object,
  buttonLabel: string,
}

CustomerInformation.defaultProps = {
  name: "",
  email: "",
  mobile: "",
  address: {},
  buttonLabel: "Contact Customer",
}

export default CustomerInformation
